import React from 'react'
import classNames from 'classnames'
import AttributedHtmlText from '#src/components/AttributedHtmlText'
import styles from './styles.css'
import { usePathContext } from '../../PathContext'

interface Props {
  className?: string
}

const QuestionHeader: React.SFC<Props> = ({ className }) => {
  const pathContext = usePathContext()

  if (pathContext.pathFlowPage.title) {
    return (
      <div className={classNames(styles.question, className)}>
        <h3 className={styles.questionText}>
          <AttributedHtmlText text={pathContext.pathFlowPage.title} testId="question-text" />
        </h3>
      </div>
    )
  }
  return null
}

export default QuestionHeader
